/* eslint-disable-next-line no-param-reassign */
/* eslint-disable react/jsx-one-expression-per-line */
/* eslint-disable react/require-default-props */
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import editIcon from 'src/assets/benefits-edit.svg';
import trashIcon from 'src/assets/benefits-trash.svg';
import { useActions } from 'src/hooks/useActions';
import { useTypedSelector } from 'src/hooks/useTypedSelector';

import { removeForbiddenWords } from 'src/utils/removeForbiddenWords';
import Lock from 'src/assets/lock_icn.svg';

import { benefitsForbiddenWords } from '../..';

import {
  CardContentContainer,
  CardContentFee,
  CardContentTitle,
  AvailableBenefitsCardContainer,
  SeparatorLine,
  SpanContent,
  CardContent,
  EditButton,
  ButtonIcon,
  RemoveButton,
  NegativeSpanContent,
  MandatoryContainer,
  MandatoryToolTip,
  MandatoryToolTipText,
  MandatoryIcon,
} from './styles';
import {
  useBenefitEnrollSelectionModalIsOpen,
  useSetBenefitEnrollSelectionModal,
  useSetBenefitType,
} from '../../enrollment.context';

type AvailableBenefitsCardProps = {
  benefitId: string;
  title: string;
  subtitle: string;
  fee: string | number;
  date: string;
  type?: string;
  imgURL?: string;
  editMode?: boolean;
  deleteMode?: boolean;
  negativeFee?: boolean;
  mandatory?: boolean;
  event?: string;
};

const AvailableBenefitsCard: React.FC<AvailableBenefitsCardProps> = ({
  // eslint-disable-next-line no-unused-vars
  imgURL,
  type,
  benefitId,
  title,
  subtitle,
  fee,
  date,
  editMode,
  deleteMode,
  negativeFee,
  mandatory,
  event = '',
}) => {
  const { t } = useTranslation();
  const { cart } = useTypedSelector(state => state.benefits.data);
  const { removeBenefitFromCart } = useActions();
  const setSelectedBenefitType = useSetBenefitType();
  const isOpen = useBenefitEnrollSelectionModalIsOpen();
  const setIsOpen = useSetBenefitEnrollSelectionModal();
  const [toolTip, setToolTip] = useState<boolean>(false);

  const handleEnrollSelectionModal = () => {
    if (type) {
      setSelectedBenefitType(type);
      setIsOpen(!isOpen);
    }
  };

  const handleDelete = () => {
    const benefit = cart?.filter(value => value.benefitId === benefitId)[0];
    if (benefit) {
      removeBenefitFromCart(benefit);
    }
  };

  const handleEdit = () => {
    const benefit = cart?.filter(value => value.benefitId === benefitId)[0];
    if (benefit) {
      // handleSpecialBenefitsEdit(benefit);
      handleEnrollSelectionModal();
    }
  };

  useEffect(() => {
    if (event === 'qle' || event === 'update-enrollment') {
      const freePlans = cart?.filter(value => value.costCalculationMethod?.toLocaleLowerCase() === 'free');
      freePlans?.forEach((plan: any) => {
        if (plan.benefitId === benefitId) {
          removeBenefitFromCart(plan);
        }
      });
    }
  }, []);

  return (
    <AvailableBenefitsCardContainer>
      <CardContentContainer>
        {mandatory ? (
          <MandatoryContainer>
            <MandatoryIcon
              onMouseOver={() => setToolTip(true)}
              onMouseLeave={() => setToolTip(false)}
              alt="lock-icon"
              src={Lock}
            />
            {toolTip ? (
              <MandatoryToolTip>
                <MandatoryToolTipText>{t('benefits.newHire.mandatory')}</MandatoryToolTipText>
              </MandatoryToolTip>
            ) : (
              ''
            )}
          </MandatoryContainer>
        ) : (
          ''
        )}
        <CardContent>
          <CardContentTitle>{removeForbiddenWords(title, benefitsForbiddenWords)}</CardContentTitle>
          <SpanContent> {date} </SpanContent>
        </CardContent>
        <div style={{ display: 'flex' }}>
          <SeparatorLine />
        </div>
        <CardContent>
          <CardContentFee>{subtitle}</CardContentFee>
          {negativeFee ? <NegativeSpanContent> {fee} </NegativeSpanContent> : <SpanContent> {fee} </SpanContent>}
        </CardContent>

        {(editMode || deleteMode) && !mandatory && (
          <div
            style={{
              display: 'flex',
              justifyContent: 'flex-end',
              alignItems: 'center',
            }}
          >
            {deleteMode && (
              <RemoveButton data-testid="remove-button" onClick={handleDelete}>
                <span>{t('global.form.remove')}</span>
                <ButtonIcon src={trashIcon} style={{ marginBottom: '3px' }} />
              </RemoveButton>
            )}
            {editMode && (
              <EditButton data-testid="edit-button" onClick={handleEdit}>
                <span>{t('global.form.edit')}</span>
                <ButtonIcon src={editIcon} style={{ marginBottom: '5px' }} />
              </EditButton>
            )}
          </div>
        )}
      </CardContentContainer>
    </AvailableBenefitsCardContainer>
  );
};

export default AvailableBenefitsCard;
